import { Moment, isMoment } from 'moment'
import * as React from 'react'
import * as Datetime from 'react-datetime'
import moment from 'moment'

// can't work out how to do this with an import statement, but it seems to work
require('react-datetime/css/react-datetime.css')

interface Props {
  hideTime?: boolean
  isValid?: (value?: Date) => boolean
  maxValue?: Date
  minValue?: Date
  onChange: (date?: Date) => void
  placeholder?: string
  value: Date | undefined
  disabled?: boolean
  bsClass?: string
  inputClass?: string
  onBlur: (date?: Date) => void
  displayCalendarAbove?: boolean
}

const handleValue = (
  handler: (date?: Date) => void,
  e: string | Moment | React.ChangeEvent<any>
) => {
  // If value is a valid moment (or blank) call the parent onChange event
  // We only want to call onChange with a valid value
  if (isMoment(e) && moment(e.creationData().input).isValid()) {
    return handler(e.toDate())
  } else if (e) {
    return null;
  } else {
    return handler(undefined)
  }
}

const onBlur = (
  handler: (date?: Date) => void,
  e: string | Moment | React.ChangeEvent<any>
) => {
  if (isMoment(e)) {
    return handler(e.toDate())
  } else if (e) {
    return null;
  } else {
    return handler(undefined)
  }
}

const isValid = (
  current: Date,
  minValue?: Date,
  maxValue?: Date,
  propsIsValid?: (value: Date | undefined) => boolean
) => {
  if (minValue !== undefined && current < minValue) {
    return false
  }
  if (maxValue !== undefined && current > maxValue) {
    return false
  }
  if (propsIsValid !== undefined) {
    return propsIsValid(current)
  }
  return true
}

export const DateTimePicker = (props: Props) => {
  return (
    <span style={{ display: 'inline-block' }} className={props.displayCalendarAbove ? 'display-calendar-above' : ''}>
      <Datetime.default
        utc={true}
        onChange={e => handleValue(props.onChange, e)}
        onBlur={e => onBlur(props.onBlur, e)}
        dateFormat="YYYY-MM-DD"
        value={props.value}
        inputProps={{
          placeholder: props.placeholder,
          disabled: props.disabled,
          className: props.inputClass !== undefined ? props.inputClass : 'form-control'
        }}
        isValidDate={e =>
          isValid(e.toDate(), props.minValue, props.maxValue, props.isValid)
        }
        timeFormat={props.hideTime ? '' : 'HH:mm:ss'}
        className={props.bsClass}
        strictParsing={true}
      />
    </span>
  )
}
